<template>
  <div class="level">
    <GG />

    <portal-target key="-1:0" class="level__gg" name="-1:0" />

    <Tower
      v-for="(tower, index) in level.towers"
      :key="index"
      :tower="tower"
      :towerId="index"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Tower from "./tower";
import GG from "./GG";

export default {
  components: { Tower, GG },
  computed: {
    ...mapState(["status", "player"]),
    ...mapGetters(["level"])
  }
};
</script>

<style lang="scss">
.level {
  display: grid;
  grid-auto-flow: column;
  column-gap: vh(8);
  grid-auto-columns: vh(25);

  align-items: flex-end;
  margin: auto;
  max-width: 100%;

  padding-bottom: vh(3);
  padding-right: vh(8);

  &__gg {
    padding-bottom: inherit;
    justify-self: flex-end;

    & > * {
      margin-left: auto;
    }
  }
}
</style>
